var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createImageApi } from './imageApi';
const api = createImageApi('dialogue-images', 'dialogue');
/** Upload a dialogue image */
export function uploadDialogueImage(data) {
    return api.upload(data);
}
/** Get dialogue images (non-archived) for level */
export function getDialogueImages(levelId) {
    return api.list(levelId);
}
/** Archive (soft delete) dialogue image */
export function archiveDialogueImage(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.archive(id);
        }
        catch (error) {
            console.error('Error archiving image:', error);
            throw error;
        }
    });
}
/** Restore archived dialogue image */
export function restoreDialogueImage(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.restore(id);
        }
        catch (error) {
            console.error('Error restoring image:', error);
            throw error;
        }
    });
}
/** Permanently delete dialogue image */
export function deleteDialogueImagePermanent(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield api.deletePermanent(id);
        }
        catch (error) {
            console.error('Error permanently deleting image:', error);
            throw error;
        }
    });
}
/** Get archived dialogue images */
export function getArchivedDialogueImages(levelId) {
    return api.listArchived(levelId);
}
